'use client';

import 'core-js/actual/array/some';
import 'core-js/actual/global-this';
import 'resize-observer-polyfill/dist/ResizeObserver.global';
